import { createSelector } from '@reduxjs/toolkit';

import { AppState } from '@modules';
import { EEACountryCodes, EEAExcludeCryptoCurrencyEnum } from '@modules/global/types';

import getOperations from '@selectors/getOperations';

const isEEACompliant = createSelector(
  [
    (state: AppState) => state.operationBlock.paymentSelect.right?.value,
    (state: AppState) => state.global.dataByIp?.code,
    getOperations,
  ],
  (currency, countryCode, operations) => {
    const { buy, buy_with_new_card, accounts_buy_exchange, accounts_buy_invoice } = operations;
    return (
      (buy || buy_with_new_card || accounts_buy_exchange || accounts_buy_invoice) &&
      Object.values(EEACountryCodes).includes(countryCode as EEACountryCodes) &&
      Object.keys(EEAExcludeCryptoCurrencyEnum).includes(currency as EEAExcludeCryptoCurrencyEnum)
    );
  }
);

export default isEEACompliant;
